import { type PortfolioAllocation } from '../types';

/**
 * Core 8 Portfolio - Default
 */
export const CORE_8_PORTFOLIO: PortfolioAllocation = {
    'Large Growth': 0.1603,
    'Large Value': 0.2006,
    'Mid Cap': 0.1859,
    'Small Cap': 0.0688,
    'International Equities': 0.1365,
    'Emerging Markets': 0.0558,
    'Real Estate': 0.0268,
    Government: 0.0011,
    Municipal: 0.0593,
    Corporate: 0.042,
    'High Yield': 0,
    'International Bonds': 0.0549,
    Cash: 0.008, // Added .0003 from Right Capital to make sum of portfolio allocation equal to 1.0
};
